import {
  Component,
  ContentChild,
  EventEmitter,
  forwardRef,
  Input,
  Output,
  signal,
  TemplateRef,
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  FormsModule,
} from '@angular/forms';
import { PayeeFormFieldComponent } from '../payee-form-field/payee-form-field.component';
import { PayeeButtonComponent } from '../../payee-buttons/payee-button/payee-button.component';
import { NgTemplateOutlet } from '@angular/common';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'payee-dropdown',
  templateUrl: './payee-dropdown.component.html',
  styleUrls: ['./payee-dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PayeeDropdownComponent),
      multi: true,
    },
  ],
  imports: [
    PayeeButtonComponent,
    NgTemplateOutlet,
    MatMenuTrigger,
    MatMenu,
    FormsModule,
    MatMenuItem,
    TranslateModule,
  ],
  host: {
    '[attr.width]': 'width()',
    '[attr.height]': 'height()',
    '[class.open]': 'dropdownOpen()',
  },
})
export class PayeeDropdownComponent
  extends PayeeFormFieldComponent
  implements ControlValueAccessor
{
  @Input() options: unknown[] = [];
  @Input() selected: unknown;
  @Output() selectedChange = new EventEmitter();
  @Input() disabled = false;
  @Input() color = 'white';
  @Input() placeholder = 'Válassz...';
  @Input() isBorderButton = true;
  @Input() isRoundButton = true;
  @Input() filterable = false;

  @ContentChild('menuDisplayTemplate')
  menuDisplayTemplateRef?: TemplateRef<unknown>;
  @ContentChild('itemDisplayTemplate')
  itemDisplayTemplateRef?: TemplateRef<unknown>;
  @ContentChild('menuButtonTemplate') menuButtonTemplateRef?: TemplateRef<unknown>;

  readonly dropdownOpen = signal(false);

  filterText = '';

  @Input() displayWith: (x: any) => string = (x) => String(x);

  get filteredOptions(): unknown[] {
    if (!this.filterable || !this.filterText) {
      return this.options;
    }
    const lower = this.filterText.toLowerCase();
    return this.options.filter((o) =>
      this.displayWith(o).toLowerCase().includes(lower),
    );
  }

  onMenuOpened(): void {
    this.filterText = '';
    this.dropdownOpen.set(true);
  }

  onChange: (obj: unknown) => void = () => {};

  writeValue(obj: unknown): void {
    this.selected = obj;
  }

  registerOnChange(fn: (obj: unknown) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(_fn: () => void): void {}

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  selectOption(option: unknown): void {
    this.selected = option;
    this.selectedChange.emit(option);
    this.onChange(option);
  }
}
